import { memo } from 'react';
import type { CSSProperties } from 'react';
import type { ImageStyle, StyleProp } from 'react-native';

// Same raster glyph the native sparkle uses. `require` of a png resolves to a
// string URL (or `{ uri }`) on web; normalize both shapes for a plain <img>.
const NOVA_SPARKLE_ICON = require('../../../assets/onboarding/icon-choose-ai.png');
const novaSparkleSrc =
  typeof NOVA_SPARKLE_ICON === 'string'
    ? NOVA_SPARKLE_ICON
    : ((NOVA_SPARKLE_ICON as { uri?: string })?.uri ?? '');

/**
 * Web Nova sparkle. Most call sites here are plain DOM (`.web.tsx` headers,
 * buttons and pills), so this draws an <img> directly rather than going through
 * react-native-web's Image wrapper. Keeps the native `{ size, style }` API so
 * shared call sites need no changes.
 */
export const NovaSparkle = memo(function NovaSparkle({
  size = 20,
  style,
}: {
  size?: number;
  style?: StyleProp<ImageStyle>;
}) {
  const extra = Array.isArray(style)
    ? (Object.assign({}, ...style) as CSSProperties)
    : (style as CSSProperties | undefined);

  return (
    <img
      src={novaSparkleSrc}
      alt=""
      aria-hidden
      width={size}
      height={size}
      style={{ flexShrink: 0, objectFit: 'contain', ...extra }}
    />
  );
});
